/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "earth-globe-59f9263d--sprite",
  "use": "earth-globe-59f9263d--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"earth-globe-59f9263d--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(-972.18 -1699.902)\"><path d=\"M984.23,1707.8a2.1,2.1,0,0,0-.2.22l-.01-.01Z\" fill=\"currentColor\" /><path d=\"M999.9,1715.283a8.32,8.32,0,0,0-8.26-8.38,8.153,8.153,0,0,0-5.58,2.23l-1.57-1.59-.26.26a2.1,2.1,0,0,0-.2.22,10.639,10.639,0,0,0,6.36,17.79c.18.02.36.04.54.05v1.31h-1.3a1.338,1.338,0,0,0-1.33,1.34h6.69a1.332,1.332,0,0,0-1.33-1.34h-1.29v-1.31a10.323,10.323,0,0,0,6.44-2.86l.01.01.47-.47-1.57-1.59A8.363,8.363,0,0,0,999.9,1715.283Zm-1.88,6.92a9.278,9.278,0,0,1-5.12,2.47,8.926,8.926,0,0,1-1.27.09,10.313,10.313,0,0,1-1.24-.08,9.525,9.525,0,0,1-5.59-15.88l.79.8a8.387,8.387,0,0,0,6.05,14.05,8.149,8.149,0,0,0,5.62-2.22Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
